import { Link } from 'react-router-dom';
import { posts } from '@/mocks/posts';

export default function BingeZone() {
  const bingePosts = posts.filter((post) =>
    ['xiafan', 'moyu'].includes(post.channel),
  );
  const [hero, ...others] = bingePosts;

  if (!hero) return null;

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-14 md:py-16">
      <div className="absolute -right-24 top-10 h-64 w-64 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="absolute -left-20 bottom-0 h-56 w-56 rounded-full bg-secondary-500/20 blur-3xl" />

      <div className="relative mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-300">
              <i className="ri-restaurant-2-line w-3.5 h-3.5 flex items-center justify-center" />
              BINGE ZONE
            </span>
            <h2 className="mt-3 font-heading text-2xl text-background-50 md:text-3xl">
              下饭专区 · 一口饭一口笑
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
              专门为饭点准备的内容清单，长度都控制在一顿饭能看完的范围内，凉了也不用担心错过剧情。
            </p>
          </div>
          <Link
            to="/channel/xiafan"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            进入下饭专区
          </Link>
        </div>

        <div className="grid gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7">
            <Link to={`/post/${hero.id}`} className="group block overflow-hidden rounded-2xl">
              <div className="relative h-64 w-full overflow-hidden bg-foreground-900 md:h-[380px]">
                <img
                  src={hero.cover}
                  alt={`${hero.title} - 下饭专区推荐`}
                  title={`${hero.title} 糖心吃瓜网`}
                  className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />
                <span className="absolute left-5 top-5 flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform group-hover:scale-110">
                  <i className="ri-play-fill w-6 h-6 flex items-center justify-center text-2xl" />
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    {hero.channelName}
                  </span>
                  <h3 className="mt-3 line-clamp-2 font-heading text-xl text-background-50 md:text-2xl">
                    {hero.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm text-background-200">
                    {hero.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          </article>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            {others.slice(0, 3).map((post) => (
              <Link
                key={post.id}
                to={`/post/${post.id}`}
                className="group flex items-center gap-4 rounded-xl border border-background-100/15 bg-background-50/5 p-3 transition-colors hover:bg-background-50/10"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-lg bg-foreground-900">
                  <img
                    src={post.cover}
                    alt={`${post.title} - 下饭清单封面`}
                    title={`${post.title} 糖心吃瓜网`}
                    className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 text-sm font-medium leading-snug text-background-100 group-hover:text-primary-300">
                    {post.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-xs text-background-400">
                    <span>{post.channelName}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center" />
                      {post.readMinutes} 分钟
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}